import React, {useEffect, useRef, useState} from "react";
import commonClose from "../../../assets/img/commonClose.png";
import {BiCaretDown} from "react-icons/bi";
import '../../../css/web/AdminCommonSetModal.css';

function AdminSpBoosterPopup({ spBoosterAddShow, closeSpBoosterAddShow, saveSpBooster, spBoosterModifyShow, closeSpBoosterModifyShow, spBoosterModifychecked, modifySpBooster }) {

    const [fields, setFields] = useState({
        seqNum: '',
        shopNm: '',
        name: '',
        optionParent: '',
        option: '',
        quantity: '',
        price: '',
        totalPrice: '',
        url: '',
        image: '',
        shopUrl: '',

    });

    useEffect(() => {
        if (spBoosterModifychecked) {
            setFields({
                seqNum: spBoosterModifychecked[0].seqNum || '',
                shopNm: spBoosterModifychecked[0].shopNm || '',
                name: spBoosterModifychecked[0].name || '',
                optionParent: spBoosterModifychecked[0].optionParent || '',
                option: spBoosterModifychecked[0].option || '',
                quantity: spBoosterModifychecked[0].quantity || '',
                price: spBoosterModifychecked[0].price || '',
                totalPrice: spBoosterModifychecked[0].totalPrice || '',
                url: spBoosterModifychecked[0].url || '',
                image: spBoosterModifychecked[0].image || '',
                shopUrl: spBoosterModifychecked[0].shopUrl || '',
            })
        }
    }, [spBoosterModifychecked])

    const [fieldOmissionMsg, setFieldOmissionMsg] = useState(false);

    // 공통 change 핸들러
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
    };

    // 필수 필드 목록 (option 제외)
    const requiredFields = ["shopNm", "name", "quantity", "url", "image", "shopUrl"];

    const validation = () => {
        const isValid = requiredFields.every(field => fields[field].trim() !== '');
        if (!isValid) {
            setFieldOmissionMsg(true);
        } else {
            if (spBoosterAddShow && !spBoosterModifychecked) {
                saveSpBooster(fields);
            } else {
                // ✅ 수정: 기존 DTO에 사용자가 수정한 필드만 덮어쓴 최종 데이터 생성
                const fullDtoWithCommonFields = {
                    ...spBoosterModifychecked[0], // 기존 모든 데이터 포함
                    ...fields                     // 사용자가 바꾼 필드만 덮어쓰기
                };
                modifySpBooster(fullDtoWithCommonFields);
            }
        }
    };

    return(
        <div className="a-common-set-modal font-t-cont c-def">
            <div className="a-c-s-m-frame">
                <div className="display-flex flex-column just-cont-sb ht-100pc">
                    <div className="ht-55 display-flex flex-row just-cont-sb align-center border-c-b m-b-40">
                        <div></div>
                        <div className="m-l-45 p-t-4"><p className="font-t-title font-s-17">
                            {spBoosterAddShow ? "부스터등록" : spBoosterModifyShow ? "부스터수정" : "상태오류"}
                        </p></div>
                        <div className="text-right m-r-7 m-t-1 c-point">
                            <img className="wd-32 ht-32 m-a-opc-07" onClick={spBoosterAddShow ? closeSpBoosterAddShow :
                                spBoosterModifyShow ? closeSpBoosterModifyShow : undefined} alt="closeImage" src={commonClose}/>
                        </div>
                    </div>
                    <div className="sm-f-body ht-100pc p-l-40 p-r-40">
                        <div className="display-flex flex-column gap10">

                            <input
                                name="shopNm"
                                value={fields.shopNm}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="한글+영문 쇼핑몰명 - 지마켓(Gmarket)"
                                maxLength={50}
                            />

                            <input
                                name="name"
                                value={fields.name}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="상품명"
                                maxLength={100}
                            />

                            <input
                                name="optionParent"
                                value={fields.optionParent}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="옵션프레임"
                                maxLength={100}
                            />

                            <input
                                name="option"
                                value={fields.option}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="옵션"
                                maxLength={100}
                            />

                            <input
                                name="quantity"
                                value={fields.quantity}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="수량"
                                maxLength={100}
                            />

                            <input
                                name="price"
                                value={fields.price}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="가격"
                                maxLength={100}
                            />

                            <input
                                name="totalPrice"
                                value={fields.totalPrice}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="최종가격"
                                maxLength={100}
                            />

                            <input
                                name="url"
                                value={fields.url}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="상품URL"
                                maxLength={100}
                            />

                            <input
                                name="image"
                                value={fields.image}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="상품이미지"
                                maxLength={100}
                            />

                            <input
                                name="shopUrl"
                                value={fields.shopUrl}
                                onChange={(e) => handleChange(e)}
                                className="admin-input-line wd-100pc ht-45 p-l-7 font-s-14"
                                placeholder="쇼핑몰URL(shopping.naver.com)"
                                maxLength={2083}
                            />


                            {fieldOmissionMsg &&
                                <div className="font-c-cancel font-s-13" style={{marginTop: "-17px"}}>옵션 또는 가격 or 최종가격을
                                    제외한 모든 필드를
                                    작성해주세요</div>
                            }

                        </div>
                    </div>
                    <div className="wd-100pc ht-80 text-center align-center">
                        {spBoosterAddShow ?
                            <button className="admin-new-btn-color wd-100 ht-45 font-s-15"
                                    onClick={validation}>등록</button>
                            :
                            spBoosterModifyShow ?
                                <button className="admin-new-btn-color wd-100 ht-45 font-s-15"
                                        onClick={validation}>수정</button>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminSpBoosterPopup
